/* ELLESANTI · tema V3 · carta regalo (prototipo V8). Nessuna libreria. CTRL+G · 30/09/2026.
   Scheda della carta: importi (varianti) che cambiano la carta disegnata e il prezzo, «Come arriva» (a me / direttamente a lei:
   i campi del destinatario di Shopify, con il fuso orario), anteprima dell'email che si scrive mentre compili, controlli,
   aggiunta al carrello con «Aggiunto al carrello»; «Acquista subito» porta al pagamento.
   Carta ricevuta: codice da copiare, codice QR di Shopify, stampa. */
(function () {
  'use strict';
  /* 09/10: il numero del carrello conta i gioielli, non le confezioni regalo */
  function nGio(c) { var n = (c && c.item_count) || 0; ((c && c.items) || []).forEach(function (x) { if (x.handle === 'confezione-regalo') n -= x.quantity; }); return n; }
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ANIM = H.classList.contains('e-anim');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var ymd = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  var fmtData = function (s) {
    var p = (s || '').split('-');
    if (p.length !== 3) return s || '';
    try { return new Intl.DateTimeFormat(H.lang || 'it', { day: 'numeric', month: 'long' }).format(new Date(+p[0], +p[1] - 1, +p[2])); } catch (e) { return s; }
  };
  var okEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); };
  var tick = function (el) { if (!ANIM || !el) return; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); };

  /* ---------------------------------------------------------------- scheda della carta regalo */
  function initScheda(root) {
    if (root._egc) return;
    root._egc = true;
    var C = {};
    try { C = JSON.parse(root.getAttribute('data-cfg') || '{}'); } catch (e) {}
    var form = $('[data-e-gc-form]', root), vid = $('[data-e-gc-vid]', root);
    var flag = $('[data-e-gc-flag]', root), ctrl = $('[data-e-gc-ctrl]', root), off = $('[data-e-gc-off]', root);
    var rcp = $('[data-e-gc-rcp]', root), err = $('[data-e-gc-err]', root);
    var F = {};
    $$('[data-e-gc-f]', root).forEach(function (el) { F[el.getAttribute('data-e-gc-f')] = el; });
    var lei = false;

    /* con lo script attivo decide la scelta «Come arriva»; senza, vale il controllo «if_present» di Shopify */
    if (flag) flag.disabled = false;
    if (ctrl) ctrl.disabled = true;
    if (off) off.value = String(new Date().getTimezoneOffset());
    if (F.send_on) { var d0 = new Date(), d1 = new Date(); d1.setDate(d1.getDate() + 90); F.send_on.min = ymd(d0); F.send_on.max = ymd(d1); }

    /* importi */
    function setAmt(b, anim) {
      $$('[data-e-gc-v]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (vid) vid.value = b.getAttribute('data-e-gc-v');
      var imp = b.getAttribute('data-imp'), pr = b.getAttribute('data-price');
      $$('[data-e-crv]', root).forEach(function (e) { if (e.textContent !== imp) { e.textContent = imp; if (anim) tick(e); } });
      $$('[data-e-gcp]', root).forEach(function (e) { if (e.textContent !== pr) { e.textContent = pr; if (anim) tick(e); } });
      $$('[data-e-gcamt]', root).forEach(function (e) { e.textContent = pr; });
      if (anim && ANIM) $$('[data-e-crvis]', root).forEach(function (c) { c.classList.remove('is-shine'); void c.offsetWidth; c.classList.add('is-shine'); setTimeout(function () { c.classList.remove('is-shine'); }, 1400); });
      if (anim && vid && history.replaceState) { try { var u = new URL(location.href); u.searchParams.set('variant', vid.value); history.replaceState(history.state, '', u.toString()); } catch (e) {} }
    }
    $$('[data-e-gc-v]', root).forEach(function (b) { b.addEventListener('click', function () { if (b.getAttribute('aria-pressed') !== 'true') setAmt(b, true); }); });

    /* come arriva */
    function setLei(v) {
      lei = v;
      root.classList.toggle('is-lei', lei);
      if (rcp) rcp.classList.toggle('is-on', lei);
      if (flag) flag.checked = lei;
      [F.name, F.email, F.message, F.send_on, off].forEach(function (el) { if (el) el.disabled = !lei; });
      if (!lei) clearErr();
      mail();
    }
    $$('[data-e-gc-come]', root).forEach(function (r) { r.addEventListener('change', function () { if (r.checked) setLei(r.value === 'lei'); }); });

    /* anteprima dell'email */
    function val(k) { return F[k] ? F[k].value.trim() : ''; }
    function fill(el, s) { if (el) el.textContent = s; }
    function mail() {
      var mh = $('[data-e-gc-mh]', root), mm = $('[data-e-gc-mm]', root), md = $('[data-e-gc-md]', root);
      if (lei) {
        var nome = val('name'), msg = val('message'), d = F.send_on ? F.send_on.value : '', em = val('email');
        fill(mh, nome ? (C.lei_h || '').replace('[nome]', nome) : (C.lei_h0 || ''));
        if (mm) { mm.textContent = msg || mm.getAttribute('data-vuoto') || ''; mm.classList.toggle('is-vuoto', !msg); }
        var q = d ? (C.il || '').replace('[data]', fmtData(d)) : (C.subito || '');
        if (em) q += ' ' + (C.a || '').replace('[email]', em);
        fill(md, q ? q + '.' : '');
      } else {
        fill(mh, C.me_h || '');
        if (mm) { mm.textContent = C.me_p || ''; mm.classList.remove('is-vuoto'); }
        fill(md, C.me_da || '');
      }
      var n = $('[data-e-gc-n]', root);
      if (n && F.message) n.textContent = F.message.value.length + ' / ' + (C.max || 200);
    }

    /* controlli */
    function setErr(el, msg) {
      var f = el && el.closest('.e-fld');
      if (!f) return;
      f.classList.toggle('is-err', !!msg);
      var m = $('.e-fld__e', f);
      if (m) m.textContent = msg || '';
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }
    function clearErr() {
      ['name', 'email', 'message', 'send_on'].forEach(function (k) { if (F[k]) setErr(F[k], ''); });
      if (err) { err.hidden = true; err.textContent = ''; }
    }
    function check() {
      if (!lei) return true;
      var ok = true;
      if (F.email) { if (!okEmail(val('email'))) { setErr(F.email, C.m_email); ok = false; } else setErr(F.email, ''); }
      if (F.send_on) {
        var v = F.send_on.value;
        if (v && ((F.send_on.min && v < F.send_on.min) || (F.send_on.max && v > F.send_on.max))) { setErr(F.send_on, C.m_data); ok = false; } else setErr(F.send_on, '');
      }
      return ok;
    }
    function firstErr() { var x = $('.e-fld.is-err input, .e-fld.is-err textarea', root); if (x) x.focus(); }
    ['name', 'email', 'message', 'send_on'].forEach(function (k) {
      if (!F[k]) return;
      F[k].addEventListener('input', function () { mail(); var f = F[k].closest('.e-fld'); if (f && f.classList.contains('is-err')) check(); });
      if (k === 'email') F[k].addEventListener('blur', function () { if (lei && val('email')) check(); });
    });
    function serverErr(j) {
      var shown = false;
      if (j && j.errors && typeof j.errors === 'object') {
        Object.keys(j.errors).forEach(function (k) {
          var v = j.errors[k], msg = Array.isArray(v) ? v.join(', ') : String(v);
          if (F[k]) { setErr(F[k], msg); shown = true; }
        });
      }
      if (shown) { firstErr(); return; }
      if (err) { err.textContent = (j && (j.description || j.message)) || C.errore || ''; err.hidden = false; }
    }

    /* «Aggiunto al carrello» */
    var panel = $('[data-e-gc-addp]', root), dim = $('[data-e-gc-addim]', root), lastFocus = null;
    function openPanel() {
      if (!panel) { location.href = ROOT + 'cart'; return; }
      var line = $('[data-e-gc-addv]', panel);
      if (line) {
        if (lei) {
          var d = F.send_on ? F.send_on.value : '';
          var quando = d ? (C.add_il || '').replace('[data]', fmtData(d)) : (C.add_subito || '');
          line.textContent = (C.add_lei || '').replace('[nome]', val('name') || C.lei || '').replace('[quando]', quando);
        } else line.textContent = C.add_me || '';
      }
      lastFocus = document.activeElement;
      panel.removeAttribute('inert'); panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open'); if (dim) dim.classList.add('is-on');
      H.classList.add('e-lock');
      setTimeout(function () { var x = $('[data-e-gc-addx]', panel); if (x) x.focus({ preventScroll: true }); }, 60);
    }
    function closePanel() {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open'); if (dim) dim.classList.remove('is-on');
      panel.setAttribute('aria-hidden', 'true'); panel.setAttribute('inert', '');
      H.classList.remove('e-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    $$('[data-e-gc-addx]', root).forEach(function (b) { b.addEventListener('click', closePanel); });
    if (dim) dim.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
    function count(n) { $$('.e-hd__count').forEach(function (c) { c.textContent = n; c.classList.toggle('is-visible', n > 0); }); }

    /* carrello */
    var BTNS = $$('[data-e-gc-add],[data-e-gc-now]', root);
    function add() {
      if (err) err.hidden = true;
      BTNS.forEach(function (b) { b.classList.add('is-busy'); });
      var fd = new FormData(form);
      fd.delete('return_to');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) { count(nGio(cart)); openPanel(); document.dispatchEvent(new CustomEvent('ellesanti:cart', { detail: cart })); })
        .catch(function (j) { serverErr(j); })
        .then(function () { BTNS.forEach(function (b) { b.classList.remove('is-busy'); }); });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!check()) { e.preventDefault(); firstErr(); return; }
        var s = e.submitter;
        if (s && s.hasAttribute('data-e-gc-now')) return;
        e.preventDefault();
        add();
      });
    }

    /* stato iniziale (anche quando il browser ricorda la scelta tornando indietro) */
    var sel = $('[data-e-gc-come]:checked', root);
    setLei(!!(sel && sel.value === 'lei'));
  }

  /* ---------------------------------------------------------------- carta ricevuta */
  function initRicevuta(scope) {
    $$('[data-e-qr]', scope).forEach(function (el) {
      if (el._egc) return;
      var go = function () {
        if (el._egc || !window.QRCode) return;
        el._egc = true;
        try { new window.QRCode(el, { text: el.getAttribute('data-e-qr'), width: 232, height: 232, imageAltText: el.getAttribute('data-alt') || '' }); } catch (e) {}
      };
      go();
      if (!el._egc) window.addEventListener('load', go);
    });
    $$('[data-e-gcr-copy]', scope).forEach(function (b) {
      if (b._egc) return;
      b._egc = true;
      b.addEventListener('click', function () {
        var inp = $('[data-e-gcr-code]');
        if (!inp) return;
        var s = $('span', b), was = s ? s.textContent : '';
        var done = function () {
          if (s) s.textContent = b.getAttribute('data-ok') || was;
          b.classList.add('is-ok');
          setTimeout(function () { if (s) s.textContent = was; b.classList.remove('is-ok'); }, 2200);
        };
        var old = function () { inp.focus(); inp.select(); try { document.execCommand('copy'); } catch (e) {} done(); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(inp.value).then(done, old);
        else old();
      });
    });
    $$('[data-e-gcr-code]', scope).forEach(function (i) { if (i._egc) return; i._egc = true; i.addEventListener('focus', function () { i.select(); }); });
    $$('[data-e-gcr-print]', scope).forEach(function (b) { if (b._egc) return; b._egc = true; b.addEventListener('click', function () { window.print(); }); });
  }

  function init(scope) {
    scope = scope || document;
    $$('[data-e-gc]', scope).forEach(initScheda);
    initRicevuta(scope);
  }
  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];
  window.EllesantiV3.hooks.push(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
